<template>
  <div>
    <CommonHeader />
    <slot></slot>
    <CommonFooter />
  </div>
</template>

<script>
import CommonHeader from "../../components/sp/CommonHeader";
import CommonFooter from "../../components/sp/CommonFooter";
export default {
  components: {
    CommonHeader,
    CommonFooter,
  },
  name: "Wrapper",
};
</script>



// WEBPACK FOOTER //
// src/components/sp/Wrapper.vue